import { Avatar, Chip, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { StandardTableActions } from "../../../Components/StandardTableActions/StandardTableActions";
import { DataTable } from "../../../Components/Table/DataTable";
import {
  IDataTableProps,
  MobileLogoRenderType,
  RenderType,
} from "../../../Components/Table/interfaces/IDataTableProps";
import { useAppSelector, IStoreState, useAppDispatch } from "../../../redux";
import PageContainer from "../../../Components/PageContainer/PageContainer";
import { CustomButton } from "../../../Components/CustomButton";
import { useNavigate } from "react-router-dom";
import {
  clearMultipleTemplatesSync,
  fetchMultipleTemplatesAsync,
  fetchMultipleTemplatesWithArgsAsync,
  ITemplate,
} from "../../../redux/settings/templates";
import { appNabarRoutes } from "../../../router/AppNavbarRoutes";
import { StandardCard } from "../../../Components/Card";
import { CustomChip } from "../../../Components/CustomChip";
import { DataTableV2 } from "../../../Components/Table/DataTavleV2";

export const TemplatesTableView = () => {
  const { data: multipleRecordsArray, loading } = useAppSelector(
    (storeState: IStoreState) =>
      storeState.settings.templates.multiple_teplates_list
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [pagination, setPagination] = React.useState({
    pageNumber: 1,
    rowsPerPage: 10,
  });

  const dataTableProps: IDataTableProps = {
    isPagination: true,
    rowsPerPageOptions: 25,
    isDataLoading: false,
    mobileLogo: {
      type: MobileLogoRenderType.reactNode,
      onMobileLogoRender: (data: any) => {
        return (
          <Avatar
            sx={{
              width: 45,
              height: 45,
              color: "#fff",
              ml: "-8px",
              mr: 2,
            }}
          ></Avatar>
        );
      },
    },

    columns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        // headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ITemplate) => {
          return (
            <StandardTableActions
              onEditClick={() =>
                navigate(
                  `${appNabarRoutes.settings.template}/manage/${row.templates_id}`
                )
              }
            />
          );
        },
      },
      {
        key: "template_name",
        headerName: "Name",
        fieldName: "template_name",
        enableSorting: false,
        renderType: RenderType.TEXT,
      },
      {
        key: "receipt_type",
        headerName: "Module",
        fieldName: "receipt_type",
        enableSorting: false,
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: false,
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ITemplate) => {
          return (
            <CustomChip
              content={row.status}
              color={row.status === "ACTIVE" ? "success" : "error"}
            />
          );
        },
      },
    ],

    items: multipleRecordsArray,
    onPageChange: (newPageNumber: number) => {
      setPagination({ ...pagination, pageNumber: newPageNumber });
    },
    onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
      setPagination({
        pageNumber: pageNumber,
        rowsPerPage: rowsPerPage,
      });
    },
  };

  React.useEffect(() => {
    dispatch(
      fetchMultipleTemplatesWithArgsAsync({
        page: pagination.pageNumber,
        rowsPerPage: pagination.rowsPerPage,
      })
    );
  }, [pagination]);

  React.useEffect(() => {
    return () => {
      dispatch(clearMultipleTemplatesSync());
    };
  }, []);
  const isLightMode = useTheme().palette.mode === "light";
  return (
    <PageContainer title="Receipts" description="inner page">
      <StandardCard
        heading="Template"
        rightHeading={
          <CustomButton
            variant="outlined"
            color="primary"
            sx={{
                display: "flex",
                marginLeft: "auto",
                marginY: 2,
                minWidth: "80px !important",
                backgroundColor: isLightMode
                  ? "var(--secondary-color)"
                  : "var(--primary-color)",
                color: isLightMode
                  ? "var(--text-light-color)"
                  : "var(--text-dark-color)",
                border: isLightMode
                  ? "var(--border-light-color) 1px solid"
                  : "var(--border-dark-color) 1px solid",
                "&:hover": {
                  backgroundColor: isLightMode
                    ? "var(--secondary-color)"
                    : "var(--tertiary-color)",
                  opacity: isLightMode ? 0.85 : 1,
                  // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                  border: isLightMode
                    ? "var(--border-light-color) 1px solid"
                    : "var(--border-dark-color) 1px solid",
                },
              }}
            onClick={() =>
              navigate(`${appNabarRoutes.settings.template}/manage`)
            }
          >
            Create New
          </CustomButton>
        }
      >
        <DataTableV2 {...dataTableProps} />
      </StandardCard>
      {/* <Stack direction="row" justifyContent="space-between" alignItems="center" my={2} >
                <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
                    <Typography variant='h2'>Template</Typography>
                </Stack>
                <CustomButton
                    variant="outlined"
                    color="primary"
                    sx={{
                        display: "flex",
                        marginLeft: "auto",
                    }}
                    onClick={() => navigate(`${appNabarRoutes.settings.template}/manage`)}
                >
                    Create New
                </CustomButton>
            </Stack> */}
    </PageContainer>
  );
};
